import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class TimePickerModalToolsService {
  /**
   * Hour start deg of time picker component
   */
  HOUR_START_DEG = 120;
  /**
   * Min start deg of time picker component
   */
  MIN_START_DEG = 90;
  /**
   * End deg of time picker component
   */
  END_DEG = 360;
  /**
   * Hour deg incr of time picker component
   */
  HOUR_DEG_INCR = 30;
  /**
   * Min deg incr of time picker component
   */
  MIN_DEG_INCR = 6;
  // EX_KEYS = [9, 112, 113, 114, 115, 116, 117, 118, 119, 120, 121, 122, 123];
  /**
   * Creates an instance of time picker modal tools service.
   */
  constructor() {}
  /**
   * Formats time picker modal tools service
   * @param hour number
   * @param minute number
   * @param format number
   * @returns string
   */
  format(hour: number, minute: number, format: string, ampm: string): string {
    return format.replace(/(hh|h|mm|ss|tt|t)/g, (event) =>
      this.reeplazer(event, hour, minute, format, ampm)
    );
  }
  /**
   * Reeplazers time picker modal tools service
   * @param event any
   * @param hour number
   * @param minute number
   * @param format string
   * @returns any
   */
  reeplazer(
    event: any,
    hour: number,
    minute: number,
    format: string,
    ampm: string
  ): any {
    const is24Hour = (format.match(/h/g) || []).length > 1;
    switch (event.toLowerCase()) {
      case "h":
        const hourParse = this.getHour(hour, true);
        return hourParse < 10 ? "0" + hourParse : hourParse;
      case "hh":
        if (ampm === "AM") {
            if (hour === 12) {
                hour = 0
            }
        } else {
            hour = hour < 12 ? hour + 12 : hour;
        }
        return hour < 10 ? "0" + hour : hour;
      case "mm":
        return minute < 10 ? "0" + minute : minute;
      case "ss":
        return "00";
      case "t":
        return is24Hour ? "" : this.getT(hour).toLowerCase();
      case "tt":
        return is24Hour ? "" : this.getT(hour);
    }
  }
  /**
   * Gets deg minutes
   * @param index number
   * @returns number
   */
  getDegMinutes(index: number): number {
    return (this.MIN_START_DEG + index * this.MIN_DEG_INCR) % this.END_DEG;
  }
  /**
   * Gets deg hours
   * @param index number
   * @returns number
   */
  getDegHours(index: number): number {
    return (this.HOUR_START_DEG + index * this.HOUR_DEG_INCR) % this.END_DEG;
  }
  /**
   * Gets hour
   * @param hour number
   * @param isTwelveHour
   * @returns number
   */
  getHour(hour: number, isTwelveHour?: boolean): number {
    return isTwelveHour ? ([0, 12].indexOf(hour) >= 0 ? 12 : hour % 12) : hour;
  }
  /**
   * Gets class for hour
   * @param hour number
   * @param index number
   * @returns any
   */
  getClassForHour(hour: number, index: number) {
    const deg = this.getDegHours(index);
    const className: any = {};
    className["rotate-" + deg] = true;
    if (hour === index + 1) {
      className["active"] = true;
    }
    return className;
  }
  /**
   * Gets class minutes
   * @param minutes number
   * @param index number
   * @returns any
   */
  getClassForMinutes(minutes: number, index: number): any {
    const deg = this.getDegMinutes(index);
    const className: any = {};
    className["rotate-" + deg] = true;
    if (index % 5 === 0) {
      className["marker"] = true;
    }
    if (minutes === index) {
      className["active"] = true;
    }
    return className;
  }
  /**
   * Gets t
   * @param hour number
   * @returns "AM" | "PM"
   */
  getT(hour: number): "AM" | "PM" {
    return hour < 12 ? "AM" : "PM";
  }
}
